
import localforage from 'localforage';

const localForageService = localforage.createInstance({
    name: "mydatabase",
    version: 1.0,
    storeName: 'mystorageobj'
})

// THIS style of invocation is what worked for me... not the variant on the gh readme. see https://codepen.io/thgreasi/pen/ojYKeE?editors=1111
localForageService.setDriver([
    localforage.INDEXEDDB,
    localforage.WEBSQL,
    localforage.LOCALSTORAGE
])
export default localForageService;